let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kqxDJ")).then(() => parcelRequire('huU6a'));